module.exports = __webpack_public_path__ + "img/Body.2b98106d.jpg";